<app-shared-modal
  *ngIf="property"
  [name]="shareEmails ? 'Email Blast' : 'Share Property'"
  [open]="open"
  (modalClose)="closeModal()"
  size="small"
  class="share-modal"
>
  <ng-container
    *ngIf="this.fromMyDeals && !this.userOrgSlug; else shareModalContent"
  >
    You need to setup your organization to share this property. Go to
    <a routerLink="/my-organization">My Organization</a> to set a name and url.
  </ng-container>

  <ng-template #shareModalContent>
    <div *ngIf="loading" class="pt-1 pb-3">
      <app-shared-loading
        position="left"
        text="Loading share content..."
      ></app-shared-loading>
    </div>

    <div *ngIf="!loading && !shareUrls" class="modal-content">
      Unable to share this property. Please try again later.
    </div>

    <div *ngIf="!loading && shareUrls" class="modal-content">
      <div>
        <span
          ><span class="font-medium">Property:</span>
          {{ property.houseNumber }}
          {{
            property.street || '' | stringTransform: 'capitalizeEachWord'
          }},</span
        >
        {{ property.city || '' | stringTransform: 'capitalizeEachWord' }},
        <span class="uppercase">{{ property.state }}</span>
        {{ property.zip }}
      </div>

      <ng-container *ngIf="!shareEmails">
        <div class="icons">
          <a class="item" (click)="shareFacebook()">
            <div class="icon">
              <img
                src="/assets/images/social-icons/social-facebook.png"
                alt="Facebook share"
              />
            </div>
            <span>Facebook</span>
          </a>
          <a class="item" (click)="shareEmails = true">
            <div class="icon">
              <img
                src="/assets/images/social-icons/social-email.png"
                alt="Email share"
              />
            </div>
            <span>Email Blast</span>
          </a>
          <a
            *ngIf="shareUrls.whatsapp"
            [href]="
              'https://web.whatsapp.com/send?text=' +
              composedContent +
              shareUrls.whatsapp
            "
            class="item"
            target="_blank"
            (click)="shareAPI('WHATSAPP')"
          >
            <div class="icon">
              <img
                src="/assets/images/social-icons/social-whatsapp.png"
                alt="Whatsapp share"
              />
            </div>
            <span>WhatsApp</span>
          </a>
          <a
            *ngIf="shareUrls.twitter"
            [href]="
              'https://twitter.com/intent/tweet?text=' +
              composedContent +
              shareUrls.twitter
            "
            class="item"
            target="_blank"
            (click)="shareAPI('TWITTER')"
          >
            <div class="icon">
              <img
                src="/assets/images/social-icons/social-x.png"
                alt="X share"
              />
            </div>
            <span>X</span>
          </a>
          <a class="item" (click)="shareSMS()">
            <div class="icon">
              <img
                src="/assets/images/social-icons/social-sms.png"
                alt="X share"
                class="sms"
              />
            </div>
            <span>SMS Blast</span>
          </a>
        </div>

        <app-property-share-copy-link
          *ngIf="shareUrls.direct_link"
          [propertyUrl]="shareUrls.direct_link"
          (shareAPI)="shareAPI($event)"
        ></app-property-share-copy-link>
      </ng-container>

      <ng-container *ngIf="shareEmails">
        <app-property-share-emails
          [propertyId]="property.id"
          (handleClose)="shareEmails = false"
        ></app-property-share-emails>
      </ng-container>
    </div>
  </ng-template>
</app-shared-modal>
